export const COLOR_WHITE = '#FFFFFF';
export const GRID_ITEM_BOX_SHADOW = 'inset 0 8px 8px -8px rgba(0,0,0,0.2)';

export const BORDER = '1px solid #D9DADB';
